import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Måste evenemangsplats godkännas i förväg?";
const SHORT_ANSWER = "Ja. Vid tillfälligt tillstånd ska serveringsytan, in- och utgångar samt säkerhetsanordningar godkännas av kommunen i förväg.";

export const Route = createFileRoute("/fraga/behover-mojligheten-kommunens-godkannande-i-forvag")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Måste evenemangsplats godkännas i förväg" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Bifoga ritning, brandskyddsdokumentation och beskrivning av tillträdeskontroll. Räkna med platsbesök från kommun, polis och räddningstjänst."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd – platsgodkännande" }}
      related={[{"to": "/fraga/hur-lange-far-tillfalligt-tillstand-vara", "label": "Hur länge kan ett tillfälligt serveringstillstånd gälla?"}, {"to": "/fraga/far-jag-foreningens-arsfest-utan-tillstand", "label": "Behöver föreningen tillstånd för årsfest med vin?"}, {"to": "/fraga/vad-galler-for-festival-och-utomhus", "label": "Vad gäller för alkoholservering på festival eller utomhus?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Måste evenemangsplats godkännas i förväg?" },
      { name: "description", content: "Ja. Vid tillfälligt tillstånd ska serveringsytan, in- och utgångar samt säkerhetsanordningar godkännas av kommunen i förväg." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/behover-mojligheten-kommunens-godkannande-i-forvag" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/behover-mojligheten-kommunens-godkannande-i-forvag" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/behover-mojligheten-kommunens-godkannande-i-forvag",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Måste evenemangsplats godkännas i förväg", url: "https://alkoholprovet.se/fraga/behover-mojligheten-kommunens-godkannande-i-forvag" },
      ]),
    ],
  }),
});
